import { render } from "./DiscoveryTool.vue?vue&type=template&id=de1c62f0&scoped=true"
import script from "./DiscoveryTool.vue?vue&type=script&lang=js"
export * from "./DiscoveryTool.vue?vue&type=script&lang=js"

import "./DiscoveryTool.vue?vue&type=style&index=0&id=de1c62f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de1c62f0"]])

export default __exports__